

import {Options, setup, Vue} from "vue-class-component";
import {computed, onMounted, reactive, toRaw, watch} from "vue";
import EditOrAddForm from "@/components/basic/EditOrAddForm.vue";

@Options({
  components: {
    EditOrAddForm,
  },
  props: {
    modalConfig: {
      type: Object,
      default: {},
    },
    form: {
      type: Object,
      default: {},
    },
    rules: {
      type: Object,
      default: {},
    },
    formConfig: {
      type: Object,
      default: {},
    },
    layoutConfig: {
      type: Object,
      default: {label: 5, wrapper: 18}
    }
  },
  emits: ['ok', 'cancel']
})

export default class editOrAddModal extends Vue {
  editInfo = setup(() => {
    const {form, modalConfig} = reactive<any>(this.$props);

    watch(() => modalConfig.visible, (cur) => {
      //console.log("watch modalConfig", cur);
      if (modalConfig === undefined || validateForm === undefined || cur.visible === false) {
        return;
      }
      validateForm.clearValidate();
    })

    const computedModalTitle = computed(() => {
      return (modalConfig.editFlag ? "编辑" : "新增") + modalConfig.modalName;
    })

    let formRef: any;
    let validateForm: any;
    const submit = () => {
      validateForm = formRef.editInfo.getValidateForm();
      validateForm.validate().then(() => {
        let info: any = toRaw(form);
        this.$emit("ok", info);
      }).catch((error: any) => {
        console.log(error);
      });
    };
    const cancel = () => {
      this.$emit("cancel", "click cancel");
    };

    const getForm = (el: any) => {
      formRef = el
    }

    onMounted(() => {
      //console.log('formRef', formRef)
    })


    return {
      computedModalTitle,
      submit,
      cancel,
      getForm
    }
  });
}


